module.exports = __webpack_public_path__ + "img/trading.72c83cfc.svg";